<template>
  <div class="box">
    <div>

      <div class="row mt-3">
        <div class="col-12 pb-1 border-bottom">
          <h5 class="h5-sor">卡密使用 <small class="text-muted"></small></h5>
        </div>
      </div>

      <div class="row mb-3 px-1 py-1" id="buy">
        <form id="kamilForm" class="w-100 mt-3" action="/user/useKamil" method="post">
          <div class="form-group row">
            <label class="col-3 col-md-2 pl-4 pr-0 col-form-label">卡密</label>
            <div class="col-8 p-0">
              <input type="text" class="form-control" placeholder="请输入产品密钥(必填)" v-model="code">
            </div>
          </div>

          <button @click="useKamil" type="button" class="btn btn-success btn-block">立即使用</button>
          <br>

        </form>
      </div>



    </div>
    <footerPage></footerPage>
  </div>
</template>

<script>
import footerPage from "@/components/userInfo/footer"
import {getUserId} from "@/axios/token";
import qs from "qs";
export default {
  name: "kamilUse",
  components:{footerPage},
  data(){
    return{
      code:'',
      user_id:getUserId()
    }
  },
  methods:{
    useKamil(){
      let data ={
        code:this.code,
        id:this.user_id
      };
      this.axios.post('/user/useKamil',qs.stringify(data)).then(res=>{
        if(res.data.code === 0){
          this.$message({
            type:"success",
            message:"使用成功"
          })
        }else if(res.data.code===2){
          this.$message("卡密已使用")
        }else if(res.data.code===3){
          this.$message("卡密版本与当前会员版本不一致")
        }else {
          this.$message('请稍后再试')
        }
      })
    }
  }
}
</script>

<style scoped>
@media (min-width: 768px) {
  .h5-sor {
    font-size: 2rem;
  }

  .account-info {
    font-size: 1rem;
  }

  .account-info > dt {
    padding-right: 0;
  }

  .container-md {
    max-width: 960px;
  }
}
::v-deep .footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>